export enum CurrencyFlag {
  CZK = 'CZE',
  EUR = 'EUR',
  USD = 'USA',
  SKK = 'SVK',
  GBP = 'GBR',
  PLN = 'POL',
  RUB = 'RUS',
  UAH = 'UKR',
  HUF = 'HUN',
  DKK = 'DNK',
  CRC = 'CRI',
  RSD = 'SRB',
  DOP = 'DOM',
  HNL = 'HND',
  HRK = 'HRV',
  CHF = 'CHE',
  JPY = 'JPN',
  AED = 'ARE',
  CNY = 'CHN',
  RON = 'ROU',
  THB = 'THA',
  SCR = 'SYC',
  BGN = 'BGR',
  IDR = 'IDN',
  LKR = 'LKA',
  AUD = 'AUS',
}
